import { configureStore } from '@reduxjs/toolkit';
import { baseAPI } from 'api/base';
import rootReducer from '../redux/reducers';
import { loadingMiddleware } from 'features/loading';
export const store = configureStore({
	reducer: rootReducer,
	middleware: getDefaultMiddleware => getDefaultMiddleware().concat(baseAPI.middleware).concat(loadingMiddleware),
	devTools: process.env.NODE_ENV !== 'production'
});
